import { User } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconUser12Line = createIcon(User, 12, "Line");
export const IconUser16Line = createIcon(User, 16, "Line");
export const IconUser20Line = createIcon(User, 20, "Line");
export const IconUser24Line = createIcon(User, 24, "Line");
export const IconUser32Line = createIcon(User, 32, "Line");
export const IconUser48Line = createIcon(User, 48, "Line");
export const IconUser64Line = createIcon(User, 64, "Line");
